"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioPicker = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_1 = require("react");
var truncate_1 = tslib_1.__importDefault(require("lodash/fp/truncate"));
var PortfolioDropdown_1 = tslib_1.__importDefault(require("./PortfolioDropdown"));
var PortfolioPickerButton_1 = tslib_1.__importDefault(require("./PortfolioPickerButton"));
var portfolioPickerUtils_1 = require("./portfolioPickerUtils");
exports.PortfolioPicker = function (_a) {
    var portfolios = _a.portfolios, portfolioGroups = _a.portfolioGroups, appliedPortfolios = _a.appliedPortfolios, setAppliedPortfolios = _a.setAppliedPortfolios, _b = _a.showTreeViewToggle, showTreeViewToggle = _b === void 0 ? true : _b, _c = _a.showSelectionPaneToggle, showSelectionPaneToggle = _c === void 0 ? true : _c, defaultPortfolioId = _a.defaultPortfolioId, _d = _a.dropdownAnchorOrigin, dropdownAnchorOrigin = _d === void 0 ? {
        vertical: 'bottom',
        horizontal: 'left',
    } : _d, _e = _a.dropdownTransformOrigin, dropdownTransformOrigin = _e === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _e, showInColumns = _a.showInColumns, onShowInColumnsToggle = _a.onShowInColumnsToggle;
    var _f = react_1.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = react_1.useState(false), isDropdownOpen = _g[0], setIsDropdownOpen = _g[1];
    var _h = react_1.useState(appliedPortfolios), selectedPortfolios = _h[0], setSelectedPortfolios = _h[1];
    var _j = react_1.useState(false), isClosedToggle = _j[0], setIsClosedToggle = _j[1];
    var portfoliosWithDefaultFlag = react_1.useMemo(function () { return portfolioPickerUtils_1.addDefaultPortfolioFlag(portfolios, defaultPortfolioId); }, [portfolios, defaultPortfolioId]);
    var portfolioCount = selectedPortfolios.length;
    var portfolioCaption = selectedPortfolios.length === 1
        ? truncate_1.default({}, selectedPortfolios[0].FullName)
        : portfolioCount + " Portfolios";
    var onClick = function (event) {
        setAnchorEl(event.currentTarget);
        setIsDropdownOpen(function (prevIsDropdownOpen) { return !prevIsDropdownOpen; });
    };
    var onClose = function () {
        setAnchorEl(null);
        setIsDropdownOpen(false);
        setIsClosedToggle(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PortfolioPickerButton_1.default, { testID: "portfoliopicker", icon: "briefcase", buttonLabel: "PORTFOLIO", selectedValue: portfolioCaption, onClick: onClick, isActive: isDropdownOpen }),
        React.createElement(PortfolioDropdown_1.default, { anchorEl: anchorEl, anchorOrigin: dropdownAnchorOrigin, transformOrigin: dropdownTransformOrigin, isDropdownOpen: isDropdownOpen, onClose: onClose, portfolios: portfoliosWithDefaultFlag, portfolioGroups: portfolioGroups, selectedPortfolios: selectedPortfolios, setSelectedPortfolios: setSelectedPortfolios, appliedPortfolios: appliedPortfolios, setAppliedPortfolios: setAppliedPortfolios, showTreeViewToggle: showTreeViewToggle, isClosedToggle: isClosedToggle, setIsClosedToggle: setIsClosedToggle, showSelectionPaneToggle: showSelectionPaneToggle, showInColumns: showInColumns, onShowInColumnsToggle: onShowInColumnsToggle })));
};
